import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VProgressCircular,{attrs:{"rotate":-90,"size":100,"width":15,"value":_vm.percentage,"color":_vm.color}},[_vm._v(" "+_vm._s(_vm.number)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }